<div class="popup-overlay">
  <div class="popup" *ngIf="bookingData as mentorData">
    <div class="popup-icon">
      <div class="checkmark">✔</div>
    </div>
    <h2>Session Booked Successfully!</h2>
    <p class="subtext">
      Your session with <strong>{{ mentorData.mentor_name }}</strong> has been
      successfully scheduled. and the meeting link will be sent to your email
      shortly.
    </p>

    <div class="session-details">
      <div class="detail">
        <span class="label">Session Type:</span>
        <span class="value">{{ mentorData.session_type }}</span>
      </div>
      <div class="detail">
        <span class="label">Date:</span>
        <span class="value">{{ mentorData.appointment_date }}</span>
      </div>
      <div class="detail">
        <span class="label">Time:</span>
        <span class="value">{{ mentorData.display_time }}</span>
      </div>
      <div class="detail">
        <span class="label">Duration:</span>
        <span class="value">{{ mentorData.duration_minutes }} mins</span>
      </div>
      <div class="detail">
        <span class="label">Amount paid:</span>
        <span class="value">
          <i class="bi bi-currency-rupee"></i>{{ mentorData.amount_paid }}
        </span>
      </div>
      <div class="detail">
        <span class="label">Transcation ID:</span>
        <span class="value">{{ razorPayId }}</span>
      </div>
    </div>

    <div class="popup-buttons">
      <button class="btn-add" (click)="goToSessionPage()">
        View My Sessions
      </button>
    </div>
    <p class="footer-text">Redirecting to My Sessions...</p>
  </div>
</div>
